





































import {
  Component,
  Vue
} from "vue-property-decorator";
import SuperPayUtil from "@/services/super_pay";
import TextScroll from "@/components/TextScroll/TextScroll.vue";
import { AppsCategory } from "@/services/super_pay/types";
import {
  back_up_can_recommend,
  back_up_show_rewards,
  download_back_up
} from "@/services/super_pay/super_pay_helper";
import PinadCoinAdd from "@/services/pinad_add_coin";
import listenNative from "@/jsbridge/service/listenNative";
import forceState from "@/services/super_pay/forceState";
import nativeStorage from "@/utils/nativeStorage/native_storage";
import { BACK_UP_HAS_ADD_COINS } from "@/utils/nativeStorage/local_keys";
@Component({
  components: { TextScroll }
})
export default class BackUpAppRecommend extends Vue {
  private showBackUpRecommend: boolean = false;
  private reward: number = 0;

  get backUpParams() {
    console.log("backUpParams", SuperPayUtil.getAppsData(AppsCategory.back_up));
    return SuperPayUtil.getAppsData(AppsCategory.back_up);
  }

  private clickRecommend() {
    forceState.set("force");
    download_back_up("free_coins", this.refreshBackUp);
  }

  private async refreshBackUp(addCoins: boolean = false) {
    this.showBackUpRecommend = await back_up_can_recommend();
    // 如果有reward，触发安卓加币逻辑
    const gotReward = await nativeStorage.get(BACK_UP_HAS_ADD_COINS)
    this.reward = gotReward ? 0 : await back_up_show_rewards();
    addCoins &&
    !this.showBackUpRecommend &&
    this.reward &&
    PinadCoinAdd.addCoin(false);
  }

  private async init(addCoins: boolean = false) {
    await this.refreshBackUp(addCoins);
    if (this.showBackUpRecommend) {
      listenNative.addListen(
        "will_enter_foreground",
        () => {
          forceState.set("force");
          this.refreshBackUp(true);
        },
        { key: "backup_app" }
      );
    }
  }

  private async created() {
    console.log("backup created");
    this.init();
  }

  private beforeDestroy() {
    listenNative.removeListen("backup_app");
  }

  private activated() {
    console.log("backup activated");
    this.init();
  }

  private deactivated() {
    listenNative.removeListen("backup_app");
  }
}
